// extracted by mini-css-extract-plugin
module.exports = {"story":"Phoenix_story__PPNdZ","intro":"Phoenix_intro__3YeZL","alertFooter":"Phoenix_alertFooter__2TMlC"};